import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Checkbox, Divider, Form, Input, Select, Modal } from 'antd';
import Steps from 'rc-steps';
import { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import StepWizard from 'react-step-wizard';
import ModalDelete from '../../../components/Shared/modal/delete';
import { StepsButton } from './BtnSave';
import Impact from './Impact';
import DPIAService from '../../../services/DPIA.service';
import init from './init.json';
import { useDpiaContext } from '../dpia.context';

import { t } from 'i18next';
import { LASTID } from './Step1';

export const STATUS_ID = {
    LOW: 'LOW',
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH',
    LERGE: 'LERGE',
    AWAY: 'AWAY',
    REDUCE: 'REDUCE',
    ACCEPTABLE: 'ACCEPTABLE',
    APPROVE: 'APPROVE',
    NOT_APPROVE: 'NOT_APPROVE',
};

export const nameCondition = (condition, t) => {
    switch (condition) {
        case STATUS_ID.LOW:
            return t('Low', { ns: 'dpia' });
        case STATUS_ID.MEDIUM:
            return t('Moderate', { ns: 'dpia' });
        case STATUS_ID.HIGH:
            return t('High', { ns: 'dpia' });
        case STATUS_ID.SMALL:
            return t('Small', { ns: 'dpia' });
        case STATUS_ID.LERGE:
            return t('Lerge', { ns: 'dpia' });
        case STATUS_ID.AWAY:
            return t('Away', { ns: 'dpia' });
        case STATUS_ID.REDUCE:
            return t('Reduce', { ns: 'dpia' });
        case STATUS_ID.ACCEPTABLE:
            return t('Acceptable', { ns: 'dpia' });
        case STATUS_ID.APPROVE:
            return t('Approved', { ns: 'dpia' });
        case STATUS_ID.NOT_APPROVE:
            return t('Not Approved', { ns: 'dpia' });
        default:
            return '-';
        // code block
    }
};

export const nameConditionRisk = (condition, t) => {
    switch (condition) {
        case STATUS_ID.LOW:
            return t('Low', { ns: 'dpia' });
        case STATUS_ID.MEDIUM:
            return t('Center', { ns: 'dpia' });
        case STATUS_ID.HIGH:
            return t('High', { ns: 'dpia' });
        default:
            return '-';
        // code block
    }
};

export default function Step2(props) {
    const identifications = Form.useWatch(
        'dpiaIdentificationList',
        props.form1
    );
    const { setStep5, setStepNo } = useDpiaContext();
    const { t } = useTranslation(['translation', 'dpia']);
    const [current, setCurrent] = useState(0);
    const [state, updateState] = useState();

    const isNotIncludes = identifications?.includes(LASTID);

    useEffect(() => {
        if (isNotIncludes) {
            props.form.resetFields();
            setStep5(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isNotIncludes, props.form]);
    useEffect(() => {
        setStepNo(5)
    }, []); 
    const onChange = (value) => {
        setCurrent(value);
        state?.SW?.goToStep(value + 1);
    };

    const setInstance = (SW) => {
        updateState({
            ...state,
            SW,
        });
    };

    const onValuesChange = (info, value) => {
        const hasEmptyRisk = value?.dpiaRiskAssessmentList?.some(
            (item) => item.risk === '' || item.risk === null
        );
        if (hasEmptyRisk && !isNotIncludes) {
            setStep5(false);
        } else {
            setStep5(true);
        }
    };

    return (
        <div hidden={!props?.isActive}>
            <div className="w-full flex justify-end">
                <Steps
                    className="bg-[#F5F6FF] rounded-md inline-step"
                    type="inline"
                    current={current}
                    onChange={onChange}
                    items={[
                        {
                            status: current === 0 ? 'process' : 'wait',
                            title: '5.1',
                        },
                        {
                            status: current === 1 ? 'process' : 'wait',
                            title: '5.2',
                        },
                        {
                            status: current === 2 ? 'process' : 'wait',
                            title: '5.3',
                        },
                    ]}
                />
            </div>
            <div className="text-2xl font-semibold text-purple-PHX">
                {t('Step', { ns: 'dpia' })} 5 : Risk assessment
            </div>
            <div className="text-[#65707A]">
                {parse(t('step5 detail', { ns: 'dpia' }))}
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                initialValues={init.riskAssessment}
                layout="vertical"
                name="riskAssessment"
                form={props?.form}
            >
                <StepWizard
                    onStepChange={({ activeStep }) => {
                        setCurrent(activeStep - 1);
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                    instance={setInstance}
                >
                    <Step51
                        isNotIncludes={isNotIncludes}
                        back={() => props?.previousStep()}
                        form={props?.form}
                    />
                    <Step52 form={props?.form} />
                    <Step53 form={props?.form} next={() => props?.nextStep()} />
                </StepWizard>
            </Form>
        </div>
    );
}

function Step51(props) {
    const { t } = useTranslation(['translation', 'dpia']);
    const { setStep5 } = useDpiaContext();
    const onNextStep = () => {
        props.form
            .validateFields()
            .then(() => {
                setStep5(true);
            })
            .catch(() => {
                setStep5(false);
            });
        props.nextStep();
    };

    return (
        <div hidden={!props?.isActive}>
            <div className="text-xl font-bold flex justify-between items-center">
                <div>
                    5.1) {t('Identifying the risk sources', { ns: 'dpia' })}
                </div>
            </div>
            <div>
                {t(
                    'Please select the topics that are potential sources of risk',
                    { ns: 'dpia' }
                )}
            </div>
            <div className="mt-4 font-bold">
                {t('Examples of risk sources', { ns: 'dpia' })}
            </div>
            <ul className="space-y-4 mb-6">
                {parse(t('5.1', { ns: 'dpia' }))}
            </ul>
            <Form.List name="dpiaRiskAssessmentList">
                {(fields, { add, remove }) => (
                    <>
                        {fields.map(({ key, name, ...restField }) => (
                            <FormObserve
                                isNotIncludes={props.isNotIncludes}
                                remove={remove}
                                fields={fields}
                                key={key}
                                name={name}
                                restField={restField}
                            />
                        ))}
                        <Form.Item>
                            <Button
                                className="text-[#1890FF]"
                                type="link"
                                onClick={() => add()}
                                icon={<PlusOutlined />}
                            >
                                <span className="underline">
                                    {t('Create additional risks', {
                                        ns: 'dpia',
                                    })}
                                </span>
                            </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>
            <Divider />
            <StepsButton previous={props?.back} next={onNextStep} />
        </div>
    );
}

const FormObserve = ({ fields, restField, name, remove, isNotIncludes }) => {
    const { t } = useTranslation(['translation', 'dpia']);
    const [openDelete, setOpenDelete] = useState(false);

    return (
        <div className="flex mb-2 relative">
            <Form.Item
                {...restField}
                name={[name, 'risk']}
                label={
                    <span className="text-base">
                        {t('Risk', { ns: 'dpia' })} {name + 1}
                    </span>
                }
                rules={[
                    {
                        required: !isNotIncludes,
                        message: t('errorText.requiredField'),
                    },
                ]}
                className="w-full"
            >
                <Input.TextArea
                    rows={4}
                    showCount
                    maxLength={800}
                    style={{ width: '100%' }}
                    placeholder={t('Identify the source of risk', {
                        ns: 'dpia',
                    })}
                />
            </Form.Item>
            {fields.length > 1 && (
                <Button
                    className="text-[#1890FF] absolute right-0"
                    type="link"
                    onClick={() => {
                        setOpenDelete(true);
                    }}
                    icon={<MinusCircleOutlined />}
                >
                    {t('Remove risk', { ns: 'dpia' })}
                </Button>
            )}
            <ModalDelete
                title={t('Remove risk', { ns: 'dpia' })}
                text={t('Do you want to remove this risk', { ns: 'dpia' })}
                open={openDelete}
                handelOk={() => {
                    remove(name);
                }}
                handelClose={() => setOpenDelete(false)}
            />
        </div>
    );
};

function Step52(props) {
    const { t } = useTranslation(['translation', 'dpia']);
    const dpiaRiskAssessmentList = Form.useWatch(
        'dpiaRiskAssessmentList',
        props?.form
    );

    useEffect(() => {
        if (dpiaRiskAssessmentList?.length > 0) {
            let _dpiaRiskAssessmentList = dpiaRiskAssessmentList.map(
                (dpia, i) => {
                    const score = calculateScore(
                        dpiaRiskAssessmentList[i]?.likelihood,
                        dpiaRiskAssessmentList[i]?.severity
                    );
                    return {
                        dpiaRiskAssessmentImpactList:
                            dpia?.dpiaRiskAssessmentImpactList || [],
                        risk: dpia?.risk || '',
                        likelihood: dpia?.likelihood || null,
                        severity: dpia?.severity || null,
                        results: score?.value || null,
                        sequence: i + 1,
                    };
                }
            );
            props?.form?.setFieldValue(
                'dpiaRiskAssessmentList',
                _dpiaRiskAssessmentList
            );
        }
    }, [dpiaRiskAssessmentList, props?.form]);

    const onNextStep = () => {
        props.nextStep();
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    return (
        <div hidden={!props?.isActive}>
            <div className="text-xl font-bold flex justify-between items-center">
                <div>5.2) {t('Risk Assessment', { ns: 'dpia' })}</div>
            </div>
            <div>
                {t('Please specify the likelihood and severity', {
                    ns: 'dpia',
                })}
            </div>
            <Form.List name="dpiaRiskAssessmentList">
                {(fields) => (
                    <>
                        {fields.map(({ key, name, ...restField }) => {
                            let score;
                            if (dpiaRiskAssessmentList?.length > 0) {
                                score = calculateScore(
                                    dpiaRiskAssessmentList[name]?.likelihood,
                                    dpiaRiskAssessmentList[name]?.severity
                                );
                            }

                            return (
                                <div key={name} className="my-4">
                                    <div className="font-semibold text-base">
                                        {t('Risk', { ns: 'dpia' })} {name + 1} :
                                    </div>
                                    {dpiaRiskAssessmentList?.length > 0 &&
                                        dpiaRiskAssessmentList[name]?.risk}
                                    <div className="grid grid-cols-3 gap-4 mt-4">
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'likelihood']}
                                            label={t('Likelihood', {
                                                ns: 'dpia',
                                            })}
                                            className="w-full mb-0"
                                        >
                                            <Select
                                                size="large"
                                                placeholder={t(
                                                    'Select Likelihood',
                                                    { ns: 'dpia' }
                                                )}
                                                style={{ width: '100%' }}
                                                options={[
                                                    {
                                                        value: STATUS_ID.LOW,
                                                        label: t('Low', {
                                                            ns: 'dpia',
                                                        }),
                                                    },
                                                    {
                                                        value: STATUS_ID.MEDIUM,
                                                        label: t('Moderate', {
                                                            ns: 'dpia',
                                                        }),
                                                    },
                                                    {
                                                        value: STATUS_ID.HIGH,
                                                        label: t('High', {
                                                            ns: 'dpia',
                                                        }),
                                                    },
                                                ]}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'severity']}
                                            label={t('Severity', {
                                                ns: 'dpia',
                                            })}
                                            className="w-full mb-0"
                                        >
                                            <Select
                                                size="large"
                                                placeholder={t(
                                                    'Select Severity',
                                                    { ns: 'dpia' }
                                                )}
                                                style={{ width: '100%' }}
                                                options={[
                                                    {
                                                        value: STATUS_ID.SMALL,
                                                        label: t('Small', {
                                                            ns: 'dpia',
                                                        }),
                                                    },
                                                    {
                                                        value: STATUS_ID.MEDIUM,
                                                        label: t('Moderate', {
                                                            ns: 'dpia',
                                                        }),
                                                    },
                                                    {
                                                        value: STATUS_ID.LERGE,
                                                        label: t('Lerge', {
                                                            ns: 'dpia',
                                                        }),
                                                    },
                                                ]}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'results']}
                                            label={t('Risk Assessment Result', {
                                                ns: 'dpia',
                                            })}
                                            className="w-full mb-0"
                                        >
                                            <div className="flex items-center space-x-4">
                                                <SvgGray color={score?.color} />
                                                <span>
                                                    {score?.label ||
                                                        'Not assessed yet'}
                                                </span>
                                            </div>
                                        </Form.Item>
                                    </div>
                                    <Divider className="mt-3 mb-3" />
                                </div>
                            );
                        })}
                    </>
                )}
            </Form.List>
            <br />
            <br />
            <StepsButton previous={onPreviousStep} next={onNextStep} />
        </div>
    );
}

function Step53(props) {
    const { t } = useTranslation(['translation', 'dpia']);
    const { setImpact } = useDpiaContext();
    const dpiaRiskAssessmentList = Form.useWatch(
        'dpiaRiskAssessmentList',
        props?.form
    );
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);

    const onPreviousStep = () => {
        props.previousStep();
    };
    const getDPIAImpact = async () => {
        setLoading(true);
        try {
            const { data } = await DPIAService.getDPIAImpact();
            if (data?.resultData) {
                setDataSource(data?.resultData);
                setImpact(data?.resultData);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        getDPIAImpact();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div hidden={!props?.isActive}>
            <div className="text-xl font-bold flex justify-between items-center">
                <div>5.3) {t('Impact of Data Processing', { ns: 'dpia' })}</div>
                <a
                    onClick={() => setOpen(true)}
                    className="text-base text-[#1890FF] underline"
                >
                    {t('Add any other impact options', { ns: 'dpia' })}
                </a>
            </div>
            <div>{t('Please specify the impact', { ns: 'dpia' })}</div>
            <Form.List name="dpiaRiskAssessmentList">
                {(fields) => (
                    <>
                        {fields.map(({ key, name, ...restField }) => (
                            <div key={name} className="my-4">
                                <div className="font-semibold text-base">
                                    {t('Risk', { ns: 'dpia' })} {name + 1} :
                                </div>
                                {dpiaRiskAssessmentList?.length > 0 &&
                                    dpiaRiskAssessmentList[name]?.risk}
                                <Form.Item
                                    {...restField}
                                    name={[
                                        name,
                                        'dpiaRiskAssessmentImpactList',
                                    ]}
                                    className="w-full mb-0"
                                >
                                    <Checkbox.Group className="space-y-2 my-4">
                                        {dataSource?.map((impact) => (
                                            <>
                                                <Checkbox
                                                    key={
                                                        impact.dpiaImpactOrganizeId
                                                    }
                                                    value={
                                                        impact.dpiaImpactOrganizeId
                                                    }
                                                >
                                                    {
                                                        impact.dpiaImpactOrganizeName
                                                    }
                                                </Checkbox>
                                                <br />
                                            </>
                                        ))}
                                    </Checkbox.Group>
                                </Form.Item>
                                <Divider className="mt-3 mb-3" />
                            </div>
                        ))}
                    </>
                )}
            </Form.List>
            <Modal
                className="_modal"
                centered
                open={open}
                onOk={() => setOpen(false)}
                onCancel={() => setOpen(false)}
                width={1200}
                footer={false}
            >
                <Impact
                    getDPIAImpact={getDPIAImpact}
                    loading={loading}
                    dataSource={dataSource}
                />
            </Modal>
            <br />
            <br />
            <StepsButton previous={onPreviousStep} next={props?.next} />
        </div>
    );
}

function calculateScore(condition1, condition2) {
    if (
        (condition1 === STATUS_ID.LOW && condition2 === STATUS_ID.SMALL) ||
        (condition1 === STATUS_ID.LOW && condition2 === STATUS_ID.MEDIUM) ||
        (condition1 === STATUS_ID.LOW && condition2 === STATUS_ID.LERGE) ||
        (condition1 === STATUS_ID.MEDIUM && condition2 === STATUS_ID.SMALL) ||
        (condition1 === STATUS_ID.HIGH && condition2 === STATUS_ID.SMALL)
    ) {
        return {
            color: '#0BB783',
            value: STATUS_ID.LOW,
            label: t('Low', { ns: 'dpia' }),
        };
    } else if (
        condition1 === STATUS_ID.MEDIUM &&
        condition2 === STATUS_ID.MEDIUM
    ) {
        return {
            color: '#FAD40B',
            value: STATUS_ID.MEDIUM,
            label: t('Center', { ns: 'dpia' }),
        };
    } else if (
        (condition1 === STATUS_ID.HIGH && condition2 === STATUS_ID.MEDIUM) ||
        (condition1 === STATUS_ID.HIGH && condition2 === STATUS_ID.LERGE) ||
        (condition1 === STATUS_ID.MEDIUM && condition2 === STATUS_ID.LERGE)
    ) {
        return {
            color: '#F64E60',
            value: STATUS_ID.HIGH,
            label: t('High', { ns: 'dpia' }),
        };
    }
}

const SvgGray = ({ color = '#C3C4CB' }) => (
    <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="15.5" cy="15" r="14.5" stroke={color} />
        <circle cx="15.4987" cy="15.0002" r="10.4167" fill={color} />
    </svg>
);
